<template>
  <!-- loading animation -->
  <div
    class="fixed h-screen w-screen bg-gray-900 inset-0 z-60 flex justify-center items-center"
    :class="{ hidden: !pageStillLoading }"
  >
    <div
      class="h-64 w-64 border-gold border-4 border-r-0 rounded-full p-4 animate-spin"
    >
      <div
        class="h-full w-full border-gold border-4 border-l-0 rounded-full"
      ></div>
    </div>
    <img
      :src="logo"
      alt="loading,nft,nft game,argons,solanart,opensea nft,nft coin,binance nft,nft token,nft market,buy nft,nfts meaning,most expensive nft,nft crypto art"
      class="h-32 w-32 absolute inset-auto animate-pulse"
    />
  </div>

  <div class="h-full w-full relative dark:bg-gray-900">
    <video
      autoplay
      loop
      class="h-screen w-screen fixed inset-0 object-cover z-10"
      poster="@/assets/bg/poster.png"
    >
      <source src="@/assets/bg/v.mp4" type="video/mp4" />
    </video>
    <img
      v-if="$route.path !== '/jobs'"
      v-show="false"
      :src="cover"
      alt="nfts,nft game,argons,Ethereum nft,opensea nft,nft coin,binance nft,nft token,nft market,buy nft,nfts meaning,most expensive nft,nft crypto art"
      class="h-screen w-screen fixed inset-0 object-cover z-10"
    />
    <div
      class="min-h-screen w-full relative overflow-x-hidden z-20 bg-opacity-30 bg-gray-900"
    >
      <NavbarComponent v-bind="{ links, logo, socials }" />
      <main class="h-full" @scroll="scrollHandler">
        <router-view />
      </main>
      <FooterComponent v-bind="{ links, socials }" id="contact" />

      <span
        v-show="showGoTop"
        class="fixed bottom-4 right-4 animate-bounce cursor-pointer"
        v-smooth-scroll
        @click="goTop"
      >
        <arrow-component direction="up" :big="false" />
      </span>

      <div class="fixed left-0 bottom-10 flex justify-start w-auto">
        <Vue3WaveAudioPlayer
          ref="wave"
          :wave_width="150"
          :wave_height="20"
          :src="require('@/assets/Music/Lofi1.mp3')"
        />
      </div>
    </div>
  </div>

  <!-- toast -->
  <div
    v-show="toast.show"
    class="flex items-center mt-2 w-auto p-4 rounded-lg shadow fixed z-50 top-0 inset-x-0 text-white max-w-lg mx-auto"
    :class="toast.color"
  >
    <div class="ml-3 font-normal">{{ toast.message }}</div>
    <Close
      :size="30"
      class="cursor-pointer ml-auto -mx-1.5 -my-1.5"
      @click="toast.close()"
    />
  </div>
</template>

<script>
// components
import NavbarComponent from "./components/navbarComponent.vue"
import FooterComponent from "./components/footerComponent.vue"
import arrowComponent from "./components/arrowComponent.vue"
import Vue3WaveAudioPlayer from "vue3-wave-audio-player"

import Close from "vue-material-design-icons/Close.vue"
import { on } from "@/mitt"
import { getScreenSizeByName, setColorByStatus } from "@/utils"

// AOS
import AOS from "aos"
import "aos/dist/aos.css"

export default {
  name: "App",
  components: {
    NavbarComponent,
    FooterComponent,
    arrowComponent,
    Close,
    Vue3WaveAudioPlayer,
  },
  data: () => ({
    toast: {
      /// toast props
      show: false,
      color: "",
      message: "",
      /// toast methods
      open(message, color, timeout = 3000) {
        this.show = true
        this.message = message
        this.color = color

        setTimeout(() => {
          this.close()
        }, timeout)
      },
      close() {
        this.message = ""
        this.color = "bg-blue-500"
        this.show = false
      },
    },
    cover: require("./assets/bg/bg.png"),
    logo: require("@/assets/logo.png"),
    pageStillLoading: true,
    links: [
      {
        label: "Story",
        href: "/",
        hash: "#story",
        external: false,
      },
      {
        label: "Road Map",
        href: "/",
        hash: "#road-map",
        external: false,
      },
      {
        label: "How To Play",
        href: "https://argons.gitbook.io/docs/guide/argons-game",
        hash: "",
        external: true,
      },
      {
        label: "Arts",
        href: "/",
        hash: "#arts",
        external: false,
      },
      {
        label: "FAQ",
        href: "/",
        hash: "#faq",
        external: false,
      },
      {
        label: "Carrier",
        href: "/jobs",
        external: false,
      },
      {
        label: "Market",
        href: "/market",
        external: false,
        badge: "soon",
      },
      {
        label: "Contact",
        href: "/",
        hash: "#contact",
        external: false,
      },
      {
        label: "WhiteList",
        href: "/white-list",
        external: false,
      },
    ],
    socials: [
      {
        src: require("@/assets/wEB2-26.png"),
        href: "https://twitter.com/argons_nft",
      },
      {
        src: require("@/assets/wEB2-27.png"),
        href: "https://discord.gg/TfExjYwbAK",
      },
      {
        src: require("@/assets/wEB2-28.png"),
        href: "https://www.instagram.com/argons.nft/",
      },
      {
        src: require("@/assets/wEB2-29.png"),
        href: "https://opensea.io/collection/argons",
      },
    ],
    showGoTop: false,
  }),
  computed: {
    hideBgIn() {
      return this.$route.path !== "/jobs"
    },
  },
  created() {
    // for toast
    on("open-toast", ({ message, status = 200 }) => {
      this.toast.open(message, setColorByStatus(status))
    })
  },
  mounted() {
    // console.log(this.$refs.wave)

    // show goTop btn
    window.addEventListener("scroll", () => {
      this.showGoTop = window.scrollY > window.innerHeight
    })

    // remove loading
    setTimeout(() => {
      this.pageStillLoading = false

      // play audio
      document.querySelectorAll("audio")[0].play()
      this.$refs.wave.audio_paused = false
    }, 1000)
  },
  watch: {
    pageStillLoading(v) {
      if (!v) {
        // init AOS
        AOS.init({
          disable: window.innerWidth < getScreenSizeByName("sm"),
        })
      }
    },
  },
  methods: {
    goTop() {
      this.$smoothScroll({
        scrollTo: document.querySelector("body"),
        hash: "#top",
      })
    },
  },
}
</script>
